import * as React from 'react';
import { IBreadcrumbItem } from '../interfaces/IBreadCrumbItem';
import Image from '../components/Image';
import CountryService from '../services/CountryService';
import { findFinalPrice } from './prices';
import * as striptags from 'striptags';
import getSchemeOrgAvailability from 'helpers/src/schema.org/ItemAvailability';
import { currencyRound } from 'helpers/src/currency/currencyRound';

const domain = process.env.REACT_APP_SHOP_URL_PROD || '';

export const renderWebsite = (path: string) => (
    <script type="application/ld+json">
        {`{
            "@context": "http://schema.org",
            "@type": "WebSite",
            "name": "Divesoft",
            "url": "${domain}${path}",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "${domain}/products?currency=*&q={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        }`}
    </script>
);

export const renderBreadCrumList = (breadCrumbs: IBreadcrumbItem[]) => {
    const items = breadCrumbs.map((b, i) => ({
        '@type': 'ListItem',
        position: i,
        name: b.value || 'Homepage',
        item: domain + b.link,
    }));
    return (
        <script type="application/ld+json">
            {`{
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                "itemListElement": ${JSON.stringify(items)}
            }`}
        </script>
    );
};

export const renderOrganization = () => {
    if ('string' === typeof process.env.REACT_APP_LDJSON_ORGANIZATION) {
        try {
            const ldjsonOrganization = JSON.parse(process.env.REACT_APP_LDJSON_ORGANIZATION);
            return (
                <script type="application/ld+json">
                    {JSON.stringify({ ...ldjsonOrganization, '@context': 'http://schema.org', '@type': 'Organization' })}
                </script> 
            );
        } catch (e) {
            return `<!-- ERROR GETTING LD+JSON OORGANIZATION -->`;
        }
    }
    return `<!-- LD+JSON ORGANIZATIION NOT CONFIGURED -->`;
};

export const renderProduct = (variant: GQL.IProductVariant, url: string) => {
    const { VATrate, currency } = CountryService.GetInstance();
    const price = findFinalPrice(variant, false, VATrate);

    const description = variant.product && variant.product.description && 'string' === typeof variant.product.description.en && striptags(variant.product.description.en) || '';
    const dotPosition = description.indexOf('.');
    // Použije se pouze první věta z description
    const shortenedDescription = striptags(dotPosition > -1 ? description.substring(0, dotPosition) : description);
    
    const ldjsonProduct = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: variant.product && variant.product.name && variant.product.name.en || undefined,
        category: variant.product && Array.isArray(variant.product.categories) && variant.product.categories.length > 0
            && variant.product.categories[0].name && variant.product.categories[0].name.en || undefined,
        image: variant.product && Array.isArray(variant.product.images) && variant.product.images.length > 0
            && Image.createUrlImage({image: variant.product.images[0].file}) || undefined,
        description: shortenedDescription || variant.product && (
                variant.product.metaDescription && (variant.product.metaDescription as any).en && striptags((variant.product.metaDescription as any).en)
                || variant.product.perex && variant.product.perex.en && striptags(variant.product.perex.en)
            )
            || undefined,
        brand: variant.product && variant.product.manufacturer && variant.product.manufacturer.name,
        sku: variant.sku,
        weight: variant.product && variant.product.weight && `${(variant.product.weight / 1000).toString().replace('.', ',')} kg` || undefined,
        // "material": "Cordura 1000, Carbon fibre.",
        offers: {
            '@type': 'Offer',
            price: currencyRound(price, currency.value),
            priceCurrency: currency.value,
            availability: variant.product
                && variant.product.availability && variant.product.availability.schemaOrg
                && getSchemeOrgAvailability(variant.product.availability.schemaOrg) || undefined,
            url: `${domain}${url}`,
        },
    };
    return (
        <script type="application/ld+json">
            {JSON.stringify(ldjsonProduct)}
        </script>
    );
};


// WEBPACK FOOTER //
// ./src/helpers/ld_json.tsx